<template>
  <v-container fluid style="padding: 0px 12px">
    <v-row>
      <v-col cols="6" style="padding: 0px">
        <v-card color="indigo" dark tile :height="contentSize">
          <v-container>
            <v-row align="center" justify="center" :style="textRatio">
              <h1 class="font-weight-regular">三日坊主を、越える。</h1>
            </v-row>
            <v-row align="center" justify="center" :style="textRatio">
              <v-card-subtitle>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-icon small> mdi-run </v-icon>
                    <span> ひとりで、 </span>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-icon small> mdi-account-heart </v-icon>
                    <span> 友達で、 </span>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-icon small> mdi-account-group </v-icon>
                    <span> グループで、 </span>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-row>
            <v-row align="center" justify="center" :style="textRatio">
              <v-card-actions>
                <v-card-text>
                  <span> Yokkame を はじめよう </span>
                </v-card-text>
                <v-btn outlined @click="googleLogin">
                  <v-col cols="1">
                    <v-icon> mdi-google </v-icon>
                  </v-col>
                  <v-col cols="11">
                    <span> ログイン </span>
                  </v-col>
                </v-btn>
              </v-card-actions>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="6" style="padding: 0px">
        <v-img src="@/assets/my-life-journal-WI30grRfBnE-unsplash.jpg" :height="contentSize" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase";
import { mapActions } from "vuex";

export default {
  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    contentSize() {
      return this.height - this.clientHeight;
    },
    textRatio() {
      return "height: " + this.contentSize / 3 + "px";
    }
  },

  data: function() {
    return {
      height: window.innerHeight
    };
  },

  methods: {
    ...mapActions("user", ["fetchUser"]),
    // Googleログインを行う
    googleLogin() {
      // Googleプロバイダオブジェクトのインスタンスを作成
      const provider = new firebase.auth.GoogleAuthProvider();
      // ポップアップウィンドウでログイン
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          const userDb = firebase
            .firestore()
            .collection("users")
            .doc(result.user.uid);
          // 新規登録ユーザーの場合はfirestoreに登録
          if (result.additionalUserInfo.isNewUser) {
            // フィールドを追加
            userDb.set({
              userAchievementPower: 0, // ユーザー達成力
              userEmail: result.user.email, // ユーザーメールアドレス
              userId: result.user.uid, // ユーザーID
              userName: result.user.displayName, // ユーザー名
              userPhotoURL: result.user.photoURL, // ユーザー画像
              userProfile: "よろしくお願いします！" // ユーザープロフィール
            });
            // フレンドサブコレクションを追加
            userDb
              .collection("friends")
              .doc(result.user.uid)
              .set({
                friendUserId: result.user.uid // 仮のユーザーフレンド情報を挿入
              });
          } else {
            // 既存ユーザーの場合はユーザーメールアドレス、名前、画像情報を更新
            userDb.update({
              userEmail: result.user.email, // ユーザーメールアドレス
              userName: result.user.displayName, // ユーザー名
              userPhotoURL: result.user.photoURL // ユーザー画像
            });
          }
        })
        .catch(() => {
          // エラーがあった場合の処理
          alert("ログインに失敗しました。");
        });
    },
    handleResize: function() {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.height = window.innerHeight;
    }
  },

  mounted: function() {
    window.addEventListener("resize", this.handleResize);
  },

  props: ["clientHeight"]
};
</script>
